/**
 * Named gap scale (MUI spacing units) for Stacks, so vertical/horizontal
 * rhythm references a role instead of a magic number.
 *
 * Section-level spacing (the gap *between* page sections) is deliberately not
 * here — it is owned by the layout primitives (PageContainer, Section), so it
 * cannot be sprinkled ad-hoc across pages.
 */
export const gaps = {
  tight: 0.5, // closely-related lines: a label and its content, title and subtitle
  snug: 1, // list items, inline clusters
  base: 2, // form fields, control rows, the common default
} as const;

/**
 * Gap between page sections. Owned by the layout containers (PageContainer and
 * the internal page wrappers); section rhythm should come from the container,
 * not be set on stacks inside a page.
 */
export const sectionGap = 3;
